module.exports = __webpack_public_path__ + "img/edge_hiver_skis.04ead18f.svg";